export default "__VITE_ASSET__CQWpLNxA__"